import { Route, Routes } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import Topbar from './Topbar';
import NavbarMain from './NavbarMain'
import SchoolMain from './SchoolMain';
import ContactUs from './ContactUs';
import Footer from './Footer';
import Home from './Home';
import MembersList from './MembersList';
import Application from './OnlineApplication/Application';
import KanalMagazine from './Magazine/KanalMagazine';
import CurrentIssue from './Magazine/CurrentIssue';
import GalleryViewer from './pages/gallery/GalleryViewer';
import VideoViewer from './pages/gallery/video/VideoViewer';
import TimerView from './OnlineApplication/cbseapplication/timerview/TimerView';
import CBSERegistration from './OnlineApplication/cbseapplication/CBSERegistration';
import PrivacyPolicy from './pages/PrivacyPolicy';
import RefundPolicy from './pages/RefundPolicy';
import TermsOfService from './pages/TermsOfService';
import ScrollToTop from './ScrollToTop';
import ReportsView from './pages/Reports/ReportsView';
import YouTubeViewer from './pages/gallery/video/YouTubeViewer';
import Checkout from './paymentGateway/Checkout';
import PaymentStatus from './paymentGateway/PaymentStatus';

function App() {
  return (
    <div className="App">
      <Topbar/>
      <NavbarMain/>
       <Routes>
         <Route path="/" element={<Home />} />
         <Route path="/schools" element={<SchoolMain />} />
         <Route path="/reports" element={<ReportsView />} />
         <Route path="/members" element={<MembersList />} />
         <Route path="/privacy-policy" element={<PrivacyPolicy />} />
         <Route path="/refund-policy" element={<RefundPolicy />} />
         <Route path="/terms-of-service" element={<TermsOfService />} />
         <Route path="/application" element={<Application />} />
         <Route path="/application/checkout" element={<Checkout />} />
         <Route path="/application/payment-status" element={<PaymentStatus />} />
         <Route path="/application/cbse" element={<TimerView />} />
         <Route path="/application/cbse/form" element={<CBSERegistration />} />
         <Route path="/kanal" element={<CurrentIssue/>} />
         <Route path="/gallery/photo" element={<GalleryViewer />} />
         <Route path="/gallery/video" element={<YouTubeViewer />} />
         <Route path="/kanal/archieves" element={<KanalMagazine />} />
       </Routes>
     <ContactUs/>
     <Footer/>
     <ScrollToTop />
    </div>
  );
}

export default App;
